<div>
  <h2>{{ 'Administration::AddOnAIFeatureSettings' | abpLocalization }}</h2>
</div>
<br />
<hr />
@if (form) {
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <div class="mt-2 fade-in-top ps-0">
      <div class="form-group">
        <cai-llm-settings
          [formGroup]="form"
          [llmConfigurationList]="llmConfigurationOptions"
          [groupedModelList]="groupedModelList"
          [enableReasoningEffortSelection]="true"
          [hideHeader]="true"
          [isUpdateMode]="true"
        >
        </cai-llm-settings>
      </div>
    </div>
    <abp-button
      (click)="submitForm()"
      iconClass="fa-solid fa-check"
      [loading]="isLoading"
      [disabled]="form?.invalid || isLoading"
    >
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </form>
}
